/* eslint-disable */
export class ActivateAccountRequest {
    code!: string | undefined;
    password!: string | number;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.code = obj.code;
        this.password = obj.password;
    }
}